import axios from "axios"
import { useReportPageContext } from "../context/useReportPageContext"

const useReportGraph = (dataset, column, ticker) => {
    const { uuid } = useReportPageContext()

    const handleUpdateGraphType = (graphType) => {
        // fetch('/reports/changeGraphType', {
        //     method: 'post',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ ticker, dataset, column, uuid, graphType })
        // })
        axios({
            method: 'post',
            url: '/reports/changeGraphType',
            data: {ticker, dataset, column, uuid, graphType }
        })
    }

    return {
        handleUpdateGraphType
    }
}

export default useReportGraph